













































import { Component, Vue } from "vue-property-decorator";
import { Icon, Button, Toast,Checkbox } from "vant";
import _ from "lodash";

@Component({
  name: "RiskDisclosure",
  components: {
    [Icon.name]: Icon,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  }
})
export default class RiskDisclosure extends Vue {
  isRead = false;
  readTime = 5;
  timer: any = null;
  isAgree = false;

  get isNextBtn(){
    if(!this.isRead || !this.isAgree){
      return true
    }else{
      return false
    }
  }
  created() {
    this.initScroll()
  }
  activated() {
    this.initScroll()
    // this.isRead = false;
    // const box6: any = document.getElementById("app");
    // this.$nextTick(() => {
    //   if(box6.scrollTo){
    //     box6.scrollTo(0,0)
    //   }else{
    //     box6.scrollTop = 0
    //   }
    //   
    //   
    //   box6.onscroll = null;
    //   let first = true;
    //   box6.onscroll = _.throttle(() => {
    //     const clientHeight = box6.clientHeight;
    //     const scrollTop = box6.scrollTop;
    //     const scrollHeight = box6.scrollHeight;
    //     
    //     
    //     if(scrollTop > 0 && first){
    //       if(box6.scrollTo){
    //         box6.scrollTo(0,0)
    //       }else{
    //         box6.scrollTop = 0
    //       }
    //       first = false
    //     }
    //     
    //     if (scrollTop + clientHeight + 10 >= scrollHeight) {
    //       this.isRead = true;
    //     }
    //   }, 100);
    // });

    // this.timer = setInterval(() => {
    //   if (this.readTime > 1) {
    //     this.readTime--;
    //   } else {
    //     this.isRead = true;
    //     this.readTime = 5;
    //     clearInterval(this.timer);
    //   }
    // }, 1000);
  }

  deactivated() {
    const box: any = document.getElementById("app");
    box.onscroll = null;
    // this.timer && clearInterval(this.timer);
  }

  isScrollBottom() {}
  initScroll(){
    this.isRead = false;
    this.$nextTick(() => {
      const box: any = document.getElementById("app");
      if(box.scrollTo){
        box.scrollTo(0,0)
      }else{
        box.scrollTop = 0
      }
      
      
      box.onscroll = null;
      let first = true;
      box.onscroll = _.throttle(() => {
        
        if((first && box.scrollTop > 0) || (this.$route.path !== location.pathname)){
          if(box.scrollTo){
            box.scrollTo(0,0)
            
          }else{
            box.scrollTop = 0
          }
          first = false
        }
        const clientHeight = box.clientHeight;
        const scrollTop = box.scrollTop;
        const scrollHeight = box.scrollHeight;
        
        
        
        if (scrollTop + clientHeight + 10 >= scrollHeight) {
          this.isRead = true;
        }
      }, 100);
    });
  }

  handleNext() {
    if (!this.isRead) {
      return Toast(this.$t("open_account.risk_disclosure.toast_fail_text"));
    }
    (this as any).$apis.getAccountSituation().then(res => {
      const { openType } = this.$route.query;
      if(openType){
        // 加开的
        (this as any).$router.push({ path: "/customer-confirm", query: (this as any).$route.query });
      }else{
        
        if (res.hb_account_status === 0 && res.hk_account_status === 0) {
          this.$router.push({
            path: "/service-opening",
            query: this.$route.query
          });
        } else {
          (this as any).$router.push({
            name: "ElectronicSign"
          });
        }
      }
      // hb_account_status  证券  hk_account_status 环球

      setTimeout(()=>{
        const box: any = document.getElementById("app");
        if(box.scrollTo){
          box.scrollTo(0,0)
        }else{
          box.scrollTop = 0
        }
      },0)
    });
  }
}
